export default "__VITE_ASSET__CfeMbtfQ__"